import lazy from './lazy';
const warningMessage = 'DEPRECATION WARNING: consume is deperecated and will be removed (use lazy instead)';
const consume = props => {
  console.warn(warningMessage);
  return lazy(props);
};
export default consume;
//# sourceMappingURL=consume.js.map